<div class="booking-search" [formGroup]="searchForm">
  <hospitality-bot-input
    class="full-width"
    [label]="label"
    controlName="search"
    [props]="{
      placeholder: placeholder,
      search: true
    }"
    [loading]="isSearching"
  ></hospitality-bot-input>

  <div
    class="res-results-list"
    infiniteScroll
    (scrolled)="loadMore()"
    [toggleScrollListener]="paginationDisabled"
  >
    <div
      class="res-result-item"
      *ngFor="let res of results"
      [class.active]="isSelected(res)"
      (click)="selectResult(res)"
    >
      <div class="res-info">
        <div class="guest-name">
          {{ res.guest }}
          <span class="res-role" *ngIf="res.role">{{ res.role }}</span>
        </div>
        <div class="res-meta">
          {{ res.res }}
          <ng-container *ngIf="res.room && res.room !== '—'">
            · Room {{ res.room }}
          </ng-container>
          <ng-container *ngIf="res.phone && res.phone !== '—'">
            · {{ res.phone }}
          </ng-container>
          <ng-container *ngIf="res.email"> · {{ res.email }}</ng-container>
        </div>
      </div>
    </div>
    <div class="no-results" *ngIf="isSearching && !results.length">
      Searching reservations...
    </div>
    <div class="no-results" *ngIf="isLoadingMore">Loading more...</div>
    <div
      class="no-results"
      *ngIf="!isSearching && !isLoadingMore && results.length === 0"
    >
      {{
        hasTypedQuery
          ? 'No matching reservation found.'
          : 'No sharer reservations found for this booking.'
      }}
    </div>
  </div>
</div>
